import { render } from "./NonLinkedTabs.vue?vue&type=template&id=242a3e4c"
import script from "./NonLinkedTabs.vue?vue&type=script&lang=js"
export * from "./NonLinkedTabs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__